import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';
import { RenderHiddenField } from '../../../../common/form';
import * as Validations from '../../../../common/form/commonValidations';
import NameInput from './GuestFields/NameInput';
import AttendingInput from './GuestFields/AttendingInput';
import MealOptionInput from './GuestFields/MealOptionInput';


class GuestRsvp extends Component {

  render() {
    const { fields, forPreview, mealOptions, selector, eventId } = this.props;
    return (
      <ul className="list-unstyled">
        {fields.map((guest, index) => {
          const eventInvitationIndex = _.findIndex(guest.event_invitations, { event_id: eventId });
          return (
            <li key={guest.id} className="rsvp-guest">
              <Field
                id={`guest-form-guest-${index}-id`}
                name={`guests[${index}].id`}
                type="hidden"
                component={RenderHiddenField}
                required
                validate={Validations.REQUIRED}
              />
              <Field
                id={`guests[${index}]-name-input`}
                name={`guests[${index}].name`}
                component={NameInput}
                validate={(value, allValues) => {
                  if (forPreview) {
                    return undefined;
                  }
                  if (value.firstName && value.familyName) {
                    return undefined;
                  }
                  const eventInvitations = allValues.guests[index].event_invitations;
                  const attendingAnyEvents = eventInvitations.some(eventInvitation => eventInvitation.rsvp_type === 'ATTENDING');
                  if (attendingAnyEvents) {
                    return {
                      firstName: value.firstName ? undefined : 'Required',
                      familyName: value.familyName ? undefined : 'Required'
                    };
                  }
                  return undefined;
                }}
                rsvpType={selector(`guests[${index}].event_invitations[${eventInvitationIndex}].rsvp_type`)}
              />
              <Field
                id={`guests-${index}-event_invitations-${eventInvitationIndex}-attending-input`}
                name={`guests[${index}].event_invitations[${eventInvitationIndex}].rsvp_type`}
                component={AttendingInput}
                validate={(value) => {
                  if (value === 'NO_RESPONSE') {
                    return 'Required';
                  }
                  return undefined;
                }}
              />
              {mealOptions && mealOptions.length > 0 && (
                <MealOptionInput
                  eventId={eventId}
                  index={index}
                  mealOptions={mealOptions}
                  selector={selector}
                  eventInvitationIndex={eventInvitationIndex}
                />
              )}
            </li>
          );
        })}
      </ul>
    );
  }
}


GuestRsvp.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({})
  ),
  mealOptions: PropTypes.arrayOf(PropTypes.shape({})),
  selector: PropTypes.func.isRequired,
  eventId: PropTypes.number,
  forPreview: PropTypes.bool,
};

export default GuestRsvp;




/** WEBPACK FOOTER **
 ** ./src/components/PublicWebsite/pages/rsvp/RsvpForm/GuestRsvp.jsx
 **/